

const Marque = () => {
    
    
    
    
    return (
        <>
<div class="relative  flex overflow-x-hidden bg-[#F7F7F7] ">
  <div class="py-1  w-full ">
    <h2 class="text-[20px] text-end animate-marquee font-Inter font-bold opacity-100"> Nҽɯ Rҽʅҽαʂҽ ƈσɱιɳɠ ʂσσɳ
    </h2>
   
  

  </div>


</div>




        </>
    );
};

export default Marque;